/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_IntroInputs */

const cs_public_site_demand_intro = /** @type {(inputs: Public_Site_Demand_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popište, co hledáte — ozveme se s nabídkami.`)
};

const en_public_site_demand_intro = /** @type {(inputs: Public_Site_Demand_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what you are looking for — we will follow up with matches.`)
};

/**
* | output |
* | --- |
* | "Tell us what you are looking for — we will follow up with matches." |
*
* @param {Public_Site_Demand_IntroInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_intro = /** @type {((inputs?: Public_Site_Demand_IntroInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_IntroInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_intro(inputs)
	return cs_public_site_demand_intro(inputs)
});